import { UserType } from "../constants/userType";
import { getUserType } from "./localStorage";

export const hasAdminUserPermissionForCTA = async () => {
  const userType = await getUserType();
  return userType === UserType.Administrator || userType === UserType.User;
};

export const hasAdminPermissionForCTA = async () => {
  const userType = await getUserType();
  return userType === UserType.Administrator;
};
